import { render } from "./CSIRTWidget.vue?vue&type=template&id=0edf326a"
import script from "./CSIRTWidget.vue?vue&type=script&lang=js"
export * from "./CSIRTWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__